import type { DraftOfferCargo } from "@/pages/shipper-cargo-list/model";
import { mapDraftOfferCargos } from "@/pages/shipper-cargo-list/ui/CargoTable/utils";
import { MobileCargoListItem } from "@/pages/shipper-cargo-list/ui/mobile/cargo-list/cargo-list-item";
import { Stack } from "@mui/material";

type Props = {
  draftOfferCargos: DraftOfferCargo[];
};

export const MobileCargoList: React.FC<Props> = ({ draftOfferCargos }) => {
  return (
    <Stack
      direction="column"
      gap={1}
      mx={-2}
      px={1}
      py={2}
      sx={{
        backgroundColor: "grey.50",
        border: "1px solid #E4E5E5",
        borderWidth: "1px 0",
      }}
    >
      {mapDraftOfferCargos(draftOfferCargos)
        .sort((a, b) => {
          return b.id - a.id;
        })
        .map((data) => (
          <MobileCargoListItem key={data.id} data={data} />
        ))}
    </Stack>
  );
};
